// extracted by mini-css-extract-plugin
export default {"textNote":"LiveDataGrid_textNote__p3nBJ","container":"LiveDataGrid_container__4z6Qf","lastUpdated":"LiveDataGrid_lastUpdated__aCfur","tableHeader":"LiveDataGrid_tableHeader__1N7Gk"};